
import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import './src/styles.css';
import App from './App';

import { ToastProvider } from './context/ToastContext';
import ErrorBoundary from './components/ErrorBoundary';

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN || "https://be48bf4b33cbd1a5b6ac01e282763533@o4510505866100736.ingest.us.sentry.io/4511014854066176",
  sendDefaultPii: true,
  environment: import.meta.env.MODE,
  enabled: import.meta.env.PROD,
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: 0.05, // Track 5% of sessions (free tier friendly)
});

// Catch unhandled promise rejections (async errors that slip through try/catch)
window.addEventListener('unhandledrejection', (event) => {
  Sentry.captureException(event.reason || new Error('Unhandled promise rejection'));
});

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <ToastProvider>
        <App />
      </ToastProvider>
    </ErrorBoundary>
  </React.StrictMode>
);